export const NOTIFICATIONS_PER_PAGE = 15;
